module.exports = __webpack_public_path__ + "media/images/icons/icon-placeholder-a716843030a4f982990e79d4b7701b6f.svg";